import { render } from "./PresentationGenerator.vue?vue&type=template&id=1f790545"
import script from "./PresentationGenerator.vue?vue&type=script&lang=js"
export * from "./PresentationGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__